<script>
import RequestObject from '@/components/page-corporate-requests/RequestObject.vue';
import RequestFilters from '@/components/page-corporate-requests/RequestFilters.vue';
import PaginationController from '@/components/base-components/PaginationController.vue';

export default {
    components: {
        RequestObject,
        RequestFilters,
        PaginationController,
    },
    computed: {
        requests() {
            return this.$store.getters.CORPORATE_REQUESTS;
        },
        isLoading() {
            return this.$store.getters.IS_REQUESTS_LOADING;
        },
        currentPage() {
            return this.$store.getters.CORPORATE_REQUESTS_CURRENT_PAGE;
        },
        maxPage() {
            return this.$store.getters.CORPORATE_REQUESTS_TOTAL_PAGES;
        },
        displayRange() {
            return this.$store.getters.CORPORATE_REQUESTS_DISPLAY_RANGE;
        },
        pagination() {
            return this.$store.getters.CORPORATE_REQUESTS_PAGINATION;
        },
    },
    methods: {
        async handlePageChange(action) {
            await this.$store.dispatch('changePage', action);
        },
        async changeLimit(event) {
            const newLimit = parseInt(event.target.value);
            this.$store.commit('SET_LIMIT', newLimit);
            await this.$store.dispatch('loadCorporateRequests');
        },
    },
};
</script>

<template>
    <div class="right_container_block">
        <div class="right_header">
            <label>Corporate Subscription Requests</label>
        </div>

        <RequestFilters />

        <div v-if="isLoading" class="loading_container">
            <p>Loading requests...</p>
        </div>

        <div v-else-if="requests.length === 0" class="no_requests">
            <p>No corporate requests found</p>
        </div>

        <div v-else>
            <div class="table_scroll_container">
                <table class="requests_table">
                    <thead>
                        <tr>
                            <th class="th_80">ID</th>
                            <th class="th_150">Company</th>
                            <th class="th_120">Contact</th>
                            <th class="th_180">Email</th>
                            <th class="th_80 th_center">Licenses</th>
                            <th class="th_120 th_center">Status</th>
                            <th class="th_120">Created</th>
                            <th class="th_100 th_center">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <RequestObject
                            v-for="request in requests"
                            :key="request.id"
                            :request="request"
                        />
                    </tbody>
                </table>
            </div>

            <div class="pagination_controls">
                <div class="show_info">
                    <span>Showing {{ displayRange }} requests</span>
                </div>

                <div class="pagination_buttons">
                    <PaginationController
                        :currentPage="currentPage"
                        :maxPage="maxPage"
                        @first="handlePageChange('first')"
                        @back="handlePageChange('prev')"
                        @next="handlePageChange('next')"
                        @last="handlePageChange('last')"
                    />
                </div>

                <div class="page_size_selector">
                    <label>Per page:</label>
                    <select :value="pagination.limit" @change="changeLimit">
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.right_container_block {
    padding: 20px;
}

.right_header {
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: 600;
    color: var(--text-color);
}

.loading_container,
.no_requests {
    padding: 40px 20px;
    text-align: center;
    color: var(--text-color-secondary);
}

.table_scroll_container {
    overflow-x: auto;
    margin-bottom: 20px;
}

.requests_table {
    width: 100%;
    min-width: 1000px;
    border-collapse: collapse;
}

.requests_table th {
    padding: 12px 15px;
    text-align: left;
    font-weight: 600;
    color: var(--text-color);
    background: var(--background-secondary);
    border-bottom: 2px solid var(--border-color);
    white-space: nowrap;
}

.th_80 {
    width: 80px;
}
.th_100 {
    width: 100px;
}
.th_120 {
    width: 120px;
}
.th_150 {
    width: 150px;
}
.th_180 {
    width: 180px;
}
.th_center {
    text-align: center;
}

.pagination_controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    border-top: 1px solid var(--border-color);
}

.show_info span {
    color: var(--text-color-secondary);
    font-size: 14px;
}

.pagination_buttons {
    flex: 1;
    display: flex;
    justify-content: center;
}

.page_size_selector {
    display: flex;
    align-items: center;
    gap: 8px;
}

.page_size_selector label {
    color: var(--text-color-secondary);
    font-size: 14px;
}

.page_size_selector select {
    padding: 6px 10px;
    border: 1px solid var(--border-color);
    border-radius: 4px;
    background: var(--background-color);
    color: var(--text-color);
    cursor: pointer;
}
</style>
